import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { CartContext } from "./CartContext";
import productData from "../Datas/productData";
import ProductVisual from "./ProductVisual";
import "../css/checkout.css";

const CheckOut = () => {
  const { cartItems } = useContext(CartContext);
  const getProductById = (id) => productData.find((product) => product.id === id);
  const availableItems = cartItems.filter((item) => getProductById(item.id));
  const total = availableItems.reduce((sum, item) => {
    const product = getProductById(item.id);
    return sum + Number(product.price) * item.quantity;
  }, 0);

  return (
    <main className="review-page">
      <section className="review-intro">
        <p className="review-kicker">CATALOGUE PREVIEW</p>
        <h1>Review your selection</h1>
        <div className="review-notice" role="status">
          <strong>No payment is taken here.</strong>
          <p>Online checkout is not currently enabled. This website does not request, process or store card numbers or security codes.</p>
        </div>
      </section>

      <section className="review-summary" aria-labelledby="summary-title">
        <h2 id="summary-title">Your selection</h2>
        {availableItems.length === 0 ? (
          <div className="review-empty"><p>Your selection is empty.</p><Link to="/shop">Browse the catalogue</Link></div>
        ) : (
          <>
            <div className="review-items">
              {availableItems.map((item, index) => {
                const product = getProductById(item.id);
                return (
                  <article className="review-item" key={`${item.id}-${item.size}-${item.color}-${index}`}>
                    <div className="review-item__visual"><ProductVisual product={product} compact /></div>
                    <div><h3>{product.name}</h3><p>{item.color} / {item.size} / Qty {item.quantity}</p></div>
                    <strong>${(Number(product.price) * item.quantity).toFixed(2)}</strong>
                  </article>
                );
              })}
            </div>
            <div className="review-total"><span>Preview total</span><strong>${total.toFixed(2)}</strong></div>
            <p className="review-fineprint">Prices are indicative and do not constitute an accepted order. Availability, delivery charges and final terms must be confirmed before purchase.</p>
          </>
        )}
      </section>

      <section className="review-actions">
        <h2>Want an availability update?</h2>
        <p>Email us without entering payment information. Please do not send card details by email.</p>
        <a href="mailto:track@uightparcel.shop?subject=Catalogue%20availability%20enquiry" className="review-email">Email an enquiry</a>
        <Link to="/privacy">How we handle personal information</Link>
      </section>
    </main>
  );
};

export default CheckOut;
